import Aos from "aos";
import React, { useEffect, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import Hero from "./Hero";
import Usecase from "./Usecase";
import About from "./About";
import Capabilities from "./Capabilities";
import SuccessStory from "./SuccessStory";
import Contact from "./Contact";
import Footer from "./Footer";
import Navbar from "../../components/Navbar";
import apiEndPoint from "../../services/apiService/apiEndPoints";
import { getApi } from "../../services/apiService/fetchMethod";
import { setFourVideo } from "../../redux/slice/videoSlice";

function HomePage() {
  const [loading, setLoading] = useState(true);
  const [selectedTab, setSelectedTab] = useState("Retail");
  const preloaderRef = useRef(null);
  const dispatch = useDispatch();
  useEffect(() => {
    (async () => {
      localStorage.clear()
      const url = apiEndPoint().FOUR_VIDEO;
      const { data, status } = await getApi({ url });
      if (status === 200) {
        dispatch(setFourVideo(data.data));
      }
    })();
  }, []);
  useEffect(() => {
    Aos.init({
      duration: 1000,
      easing: "ease-in-out",
      once: true,
      mirror: false,
    });
  }, []);
  useEffect(() => {
    const preloader = preloaderRef.current;
    setTimeout(() => {
      preloader.classList.add("loaded");
    }, 500);
    setTimeout(() => {
      setLoading(false);
    }, 1500);
  }, []);
  if (loading) {
    return (
      <div id="preloader" ref={preloaderRef}>
        <div className="line"></div>
      </div>
    );
  }
  return (
    <div>
      <Navbar />
      <Hero />
      <Usecase selectedTab={selectedTab} setSelectedTab={setSelectedTab} />
      <About />
      <Capabilities />
      <SuccessStory />
      <Contact />
      <Footer setSelectedTab={setSelectedTab} />
    </div>
  );
}

export default HomePage;
